module.exports = __webpack_public_path__ + "img/Map.ff262e68.png";